// useWsReseed runs `onReconnect` exactly once each time the WS drops and
// re-opens — never on the initial connect, never as a continuous poll
// (FRONTEND-REALTIME). A REST-seeded view passes a re-fetch that catches the
// gap of events missed while the socket was down; the live WS tail then resumes
// from the fresh seed. The callback is held in a ref so the onReconnect
// subscription does not rebind on every render (a fresh closure each render
// would otherwise churn the registry).

import { useEffect, useRef } from 'react'
import { useWsOptional } from '../ws/WsContext'

export function useWsReseed(onReconnect: () => void): void {
  const client = useWsOptional()
  const cbRef = useRef(onReconnect)
  cbRef.current = onReconnect
  useEffect(() => {
    if (!client) return
    return client.onReconnect(() => cbRef.current())
  }, [client])
}
